export const getExtension = (url: string) => {
  const parts = url.split('/');
  const filename = parts[parts.length - 1];

  const extension = filename.split('.').pop();

  return extension;
};
